import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className,
      style = props.style;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    className: className,
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 16 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upgrade_icon",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(3.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.72727273,5.6 L0,5.6 L5,0 L10,5.6 L7.27272727,5.6 L7.27272727,8.4 L2.72727273,8.4 L2.72727273,5.6 Z M2.72727273,11.2321839 L2.72727273,10.2666667 L7.27272727,10.2666667 L7.27272727,11.2321839 L2.72727273,11.2321839 Z M2.72727273,14 L2.72727273,13.0344828 L7.27272727,13.0344828 L7.27272727,14 L2.72727273,14 Z",
    id: "\uD83C\uDFA8-Icon-Color"
  }))));
});